export default __webpack_public_path__ + "static/media/2 amjad.9e7277ac.png";